<template lang="html">
  <div id="user-access-page" class="placed-backg">

    <div class="container">
      <div class="row mx-0 flex-center-xy page-size">

        <div class="form-container">
          <div class="box-color"><i><u class="fas fa-user"></u></i></div>

          <b-form class="form" @submit="recoverPassword()">

            <h1 class="mb-3">Reset password</h1>

            <p class="mb-3">
              Enter your email address. We will send you a message with the steps to reset your password.
            </p>

            <b-form-group>
              <b-form-input type="email"
                            v-model="form.email"
                            required
                            placeholder="Email">
              </b-form-input>
            </b-form-group>

            <p class="mb-3">
              <router-link to="/login">Remember your password? Sign in!</router-link>
            </p>

            <b-form-group>
              <b-button type="submit" class="btn-blue" variant="primary">Reset password</b-button>
            </b-form-group>

          </b-form>
        </div>

      </div>
    </div>

    <sweet-modal :icon="modal.icon" :blocking="modal.block" :hide-close-button="modal.block" ref="modalAlert">
      <div class="fa-3x" v-if="modal.icon== ''"><i class="fas fa-spinner fa-pulse"></i></div><br/>
      <div v-html="modal.msg"></div>
      <b-button v-if="modal.icon == 'success'" @click="toHome" class="mt-3 btn btn-info btn-s1 b-pink" style="width: 90%;">Continue</b-button>
    </sweet-modal>

  </div>
</template>

<script>
export default {
  data(){
    return{
      form: {
        email: ''
      },

      modal:{
        msg:'',
        icon:'',
        block:false,
      },
    }
  },

  methods: {
    recoverPassword(){
      this.modal.block = true;
      this.modal.icon = '';
      this.modal.msg = 'Loading ...';
      this.$refs.modalAlert.open();

      axios.post(tools.url("/api/resetpassword"),this.form).then((response)=>{
        this.modal.block = false;
        this.modal.icon = 'success';
        this.form.email = null;
        this.modal.msg = 'Your password has been reset. Check your email for the next steps.';
      }).catch((error)=>{
        this.modal.block = false;
        this.modal.icon = 'error';
        this.modal.msg = error.response.data.msg;
      });
    },

    toHome(){
      this.$refs.modalAlert.close();
    }
  }
}
</script>
